<template>
  <div class="main">
    <div class="video">
      <video
        ref="videoTop"
        v-show="!tabShow"
        controls
        autoplay="autoplay"
        muted
        :src="videoTab === 'cn' ? '/video/about.mp4' : 'https://src-glp-u-resource.growlib.com/school-level-platform/2026519/53023378aff845c91423a421778f1862.mp4'"
      ></video>
      <div class="videoTabs">
        <span :class="{ active: videoTab === 'cn' }" @click="videoTab = 'cn'">中文版</span>
        <span class="divider">|</span>
        <span :class="{ active: videoTab === 'en' }" @click="videoTab = 'en'">国际版</span>
      </div>
    </div>
    <div class="introduce">
      <div class="title">企业介绍</div>
      <div class="desc">
        格如灵科技成立于2016年，注册于北京，分别在上海 、武汉、南昌 、重庆、成都 、西安 、青岛等地设立公司及办事处，是国内领先的虚拟现实软硬件研发及推广的高新技术企业。秉持“用创新的教与学服务每个人”的使命，深耕教育与文旅领域，致力于以技术驱动知识传递效率提升，赋能全球教学实训与文化体验升级。
      </div>
      <div class="desc">
        核心技术实力与研发体系
      </div>
      <div class="desc">
        产品研发依托北京博士后工作站，统筹北京、南昌、苏州三大研发中心，开展全学段职普融通研究，促进职普教育优势互补。北京研发团队围绕国家人才培养战略，探索人工智能融合虚拟现实赋能高等与职业教育，推进“教”与“学”数字化改革。其人工智能全栈解决方案已在多所高等与职业学校落地，还参与多所学校的“双高建设计划”方案论证。
      </div>
      <div class="desc">
        教育领域
      </div>
      <div class="desc">
        在教育领域，以优质教学资源为核心，聚焦高等与职业教育及企业实训，覆盖智能制造、旅游管理、畜牧兽医、能源化工、艺术体育等多个数字教育及行业重点应用领域，提供虚拟仿真实训基地、国家级虚拟仿真金课、远程实训平台等一体化解决方案。公司深度参与国家“双高建设计划”，自主研发智慧教学平台，结合裸眼一体机与大空间交互技术，构建沉浸式教学场景，探索智慧教育赋能高等与职业教育的创新路径。
      </div>
      <div class="desc">
        文旅领域
      </div>
      <div class="desc">
        在文旅领域，格如灵科技以“科技+文化创意”为核心，深耕新数字展馆、新城市文旅与新景区文旅，提供从内容创作到运营服务的一体化解决方案。借助VR/AR、数字孪生等技术，为文旅场景打造虚实融合的沉浸式体验。
      </div>
      <div class="desc">
        截至2026年5月，公司已拥有231项(含1项在申请)软件著作权、64项专利(含11项在审)，连续六年入选“中国VR 50强”，获评北京、江西“专精特新”企业及种子独角兽企业，成功落地近千个项目，获客户与行业高度认可。
      </div>
    </div>
    <div class="oneStop">
      <div>
        <div class="headline">用创新的教与学服务每个人</div>
        <div class="type">
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625685577ec8d/712187856.png"
              alt=""
            />
            <span class="title">我们的使命</span>
            <span class="desc"
              >用创新的教与学<br>服务每个人
            </span>
          </div>
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625685583c178/159750107.png"
              alt=""
            />
            <span class="title">我们的愿景</span>
            <span class="desc"
              >成为元宇宙教学实训<br>的领先企业
            </span>
          </div>
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62568558e9003/226459578.png"
              alt=""
            />
            <span class="title">我们的价值观</span>
            <span class="desc"
              >坚持以客户为中心，高质量服务每一个客户；拼搏、担当、创新、分享公开透明、承诺兑现</span
            >
          </div>
        </div>
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/other/bigmap.png"
          alt=""
        />
        <span class="site"
          >格如灵科技在上海 、武汉、南昌 、重庆、成都 、西安 、青岛等地设立公司及办事处</span
        >
        <span></span>
      </div>
    </div>
    <div class="filiale">
      <div class="headline">各地公司</div>
      <div class="content">
        <div class="list">
          <div class="title">北京公司总部</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>朝阳区酒仙桥路甲4号宏源大厦13层</span>
          </div>
        </div>
        <div class="list">
          <div class="title">上海公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>闵行区浦江镇月路1388号伍信禾风广场1幢2号楼507室</span>
          </div>
        </div>
        <div class="list">
          <div class="title">江西公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>红谷滩新区岭口路888号物联网产业创新中心6楼</span>
          </div>
        </div>
        <div class="list">
          <div class="title">苏州公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>相城区元和街道云泉街15号鑫亿办公空间360室</span>
          </div>
        </div>
        <div class="list">
          <div class="title">武汉分公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>洪山区文化大道555号融创智谷二期B1栋7层01室</span>
          </div>
        </div>
        <div class="list">
          <div class="title">西安分公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>雁塔区沣惠南路18号唐沣国际广场B座0902A室</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videoTab: 'cn',
    };
  },
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  overflow: hidden;
  padding-bottom: 100px;
  .video {
    display: block;
    z-index: 10;
    position: relative;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/about_video.png);
    background-size: 100% 100%;
    padding: 60px 0;
    width: 100%;
    .videoTabs {
      text-align: center;
      margin-top: 20px;
      span {
        font-size: 16px;
        color: #999;
        cursor: pointer;
        &.active {
          color: #f27529;
          font-weight: 600;
        }
        &.divider {
          margin: 0 16px;
          cursor: default;
          color: #ccc;
        }
      }
    }
    video {
      width: 1200px;
      height: 675px;
      margin: 0 auto;
      position: relative;
      display: block;
    }
    img {
      width: 100%;
      height: 100%;
      display: none;
    }
  }
  .introduce {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 70px;
    .title {
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      padding: 69px 0 45px 0;
      text-align: center;
    }
    .desc {
      font-size: 18px;
      font-weight: 400;
      color: #000000;
      line-height: 48px;
      text-align: justify;
      text-indent: 2em;
    }
  }
  .oneStop {
    padding-top: 62px;
    width: 100%;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/about_ditu.png);
    background-size: 100% 100%;
    padding-bottom: 71px;
    > div {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      .headline {
        font-size: 28px;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
        text-align: center;
      }
      .type {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 74px;
        .list {
          width: 280px;
          img {
            width: 45px;
            margin: 0 auto;
            display: block;
          }
          .title {
            display: block;
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            color: #000000;
            line-height: 22px;
            padding-top: 22px;
            position: relative;
          }
          .title::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -14px;
            margin-left: -14px;
            width: 28px;
            height: 4px;
            background: #ef623d;
            box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
            border-radius: 2px;
            opacity: 0.59;
          }
          .desc {
            display: block;
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 29px;
            padding-top: 22px;
          }
        }
      }
      > img {
        width: 100%;
        margin-top: 75px;
      }
      .site {
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #7b8596;
        line-height: 25px;
        padding-top: 30px;
        display: block;
      }
    }
  }
  .filiale {
    .headline {
      padding: 70px 0 90px 0;
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      text-align: center;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      .list {
        width: 30%;
        margin-right: 5%;
        margin-bottom: 33px;
        .title {
          font-size: 16px;
          font-weight: 500;
          color: #f27529;
          line-height: 1;
        }
        .site {
          display: flex;
          align-items: center;
          margin-top: 15px;
          img {
            width: 14px;
            margin-right: 6px;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
      }
      .list:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
@media (max-width: 1000px) {
  .main {
    padding-bottom: 60px;
    .video {
      width: 100%;
      height: auto;
      margin-top: 0;
      padding: 40px 0;
      video {
        width: 100%;
        height: auto;
        min-height: 200px;
      }
      .videoTabs {
        margin-top: 16px;
        span {
          font-size: 26px;
        }
      }
    }
    .introduce {
      width: 100%;
      padding: 0 48px 60px;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        padding: 50px 0 30px 0;
      }
      .desc {
        font-size: 26px;
        line-height: 44px;
      }
    }
    .oneStop {
      padding-top: 60px;
      padding-bottom: 60px;
      > div {
        width: 100%;
        padding: 0 48px;
        box-sizing: border-box;
        .headline {
          font-size: 36px;
        }
        .type {
          flex-direction: column;
          align-items: center;
          margin-top: 40px;
          .list {
            width: 100%;
            margin-bottom: 50px;
            img {
              width: 60px;
            }
            .title {
              font-size: 30px;
              padding-top: 16px;
            }
            .desc {
              font-size: 24px;
              line-height: 40px;
              padding-top: 20px;
            }
          }
        }
        > img {
          width: 100%;
          margin-top: 40px;
        }
        .site {
          font-size: 24px;
          padding-top: 24px;
        }
      }
    }
    .filiale {
      .headline {
        font-size: 36px;
        padding: 50px 0 40px 0;
      }
      .content {
        width: 100%;
        padding: 0 48px;
        box-sizing: border-box;
        .list {
          width: 100%;
          margin-right: 0;
          margin-bottom: 36px;
          .title {
            font-size: 28px;
          }
          .site {
            margin-top: 12px;
            img {
              width: 20px;
            }
            span {
              font-size: 24px;
              line-height: 36px;
            }
          }
        }
        .list:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
